import { Group, Stack, Text } from "@mantine/core"
import { CountryFlag } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import type { BusinessPartnerRepositorySuggestionResponseDto } from "~/gen/api/types/BusinessPartnerRepositorySuggestionResponseDto.ts"

import {
  formatBusinessPartnerRepositoryAddress,
  formatBusinessPartnerRepositoryRegistrationIds,
  getBusinessPartnerRepositoryCountryLabel,
  toCountryIso3166OrNull,
} from "~/pages/Admin/components/Fields/BusinessPartnerRepositoryAutocomplete/utils.ts"

type Props = {
  suggestion: BusinessPartnerRepositorySuggestionResponseDto
}

export const BusinessPartnerRepositorySuggestionOption = ({
  suggestion,
}: Props) => {
  const { t } = useTranslation("traceability", {
    keyPrefix: "contactModal.businessPartnerRepository",
  })
  const countryIso = toCountryIso3166OrNull(suggestion.country)

  return (
    <Stack gap={0} w="100%" py={4}>
      <Text fw={700} size="sm" style={{ flex: 1, minWidth: 0 }}>
        {suggestion.name}
      </Text>
      <Group gap={4}>
        {countryIso ? (
          <CountryFlag countryIso3166={countryIso} width={14} />
        ) : null}
        <Text fz="sm" c="dimmed">
          {formatBusinessPartnerRepositoryAddress(
            suggestion,
            t("addressUnavailable")
          )}
          {suggestion.country
            ? `, ${
                getBusinessPartnerRepositoryCountryLabel(suggestion.country) ??
                ""
              }`
            : ""}
        </Text>
      </Group>
      {suggestion.registrationIds.length > 0 ? (
        <Text fz="xs" c="dimmed">
          {formatBusinessPartnerRepositoryRegistrationIds(
            suggestion.registrationIds
          )}
        </Text>
      ) : null}
    </Stack>
  )
}
